import * as yup from "yup";
export interface BankDetail {
  id: number | null;
  account_Holder_Name: string;
  employeeId: number;
  employeeName: string;
  bank_Name: number;
  bankName: string;
  account_Number: string;
  check_account_Number?: string;
  branch_Name: string;
  ifsc_Code: string;
}

type BankDetailKey = keyof BankDetail;

export interface BankDetailHeader {
  key: BankDetailKey;
  label: string;
}

export interface props {
  employeeId: number | null
}

export interface IBankDetail {
  account_Holder_Name: string;
  bank_Name: number;
  account_Number: string;
  check_account_Number: string;
  ifsc_Code: string;
  branch_Name: string;
}

export interface BOption {
  id: number;
  bank_Name: string;
}

export const BankSchema = yup.object({
  account_Holder_Name: yup.string().required("Name as per bank account required"),
  account_Number: yup.string().matches(/^\d{9,18}$/, "Invalid Account Number").required("Account Number is required"),
  check_account_Number: yup.string()
    .oneOf([yup.ref("account_Number"), undefined], "Account Numbers must match")
    .required("Please re-enter Account Number"),
  ifsc_Code: yup.string().matches(/^[A-Z]{4}0[A-Z0-9]{6}$/, "Invalid IFSC Code e.g. SBIN0001234").required("IFSC Code is required"),
  bank_Name: yup.number().required("Bank Name is required"),
  branch_Name: yup.string().required("Branch is required"),
});


export const BankDetailHeaders: BankDetailHeader[] = [
  { key: "account_Holder_Name", label: "Name as per bank" },
  { key: "bankName", label: "Bank Name" },
  { key: "account_Number", label: "Account Number" },
  { key: "ifsc_Code", label: "IFSC Code" },
  { key: "branch_Name", label: "Branch" },
];
